import { ApiGradProgram } from 'api/gradSchools/types/ApiGradProgram';
import { ApiUnpublishedGradProgram } from 'api/gradSchools/types/ApiUnpublishedGradProgram';

// Types

export type MainStoreGradSchoolsGradProgramsState = {
  byId: Record<
    string,
    {
      gradProgram: ApiGradProgram | ApiUnpublishedGradProgram;
      isFetching?: boolean;
    }
  >;
};

export type FetchGradProgramRequestAction = {
  type: 'GRAD_SCHOOLS_FETCH_PROGRAM_REQUEST';
  programId: string;
};

export type FetchGradProgramSuccessAction = {
  type: 'GRAD_SCHOOLS_FETCH_PROGRAM_SUCCESS';
  program: ApiGradProgram;
};

export type MainStoreGradSchoolsGradProgramsAction =
  | FetchGradProgramRequestAction
  | FetchGradProgramSuccessAction;

// Reducer

export function gradProgramsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreGradSchoolsGradProgramsState = {
    byId: {},
  },
  action: MainStoreGradSchoolsGradProgramsAction,
) {
  switch (action.type) {
    case 'GRAD_SCHOOLS_FETCH_PROGRAM_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.programId]: {
            ...state.byId[action.programId],
            isFetching: true,
          },
        },
      };

    case 'GRAD_SCHOOLS_FETCH_PROGRAM_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.program.id]: {
            gradProgram: action.program,
            isFetching: false,
          },
        },
      };

    default:
      return state;
  }
}
